import React, { Component } from 'react';
import DjangoCSRFToken from './djangocrsf.js';
import './../css/signin.css';
import aidao from './../assets/images/aidao_outlined_grey.png';
import content from './data/content.js';

export default class Setup extends Component {
  render() {

    var data = content[0]["page"]["setup"];

    var email = window.email;
    console.log(email);
    var token = "";
    var uidb64 = "";
    if (window.reset) {
      token = window.token;
      uidb64 = window.user;
    }

    return (
      <div>

            <div class="container">
              <div class="fixed-card-box">
                <div class="logo m-t-30 m-b-30"><img src={aidao} alt="aidao logo"/>
                </div>
                <form method="post" action="/setup"><DjangoCSRFToken />

                <h3 class="m-t-20 m-b-20 text-center">{data.reset}</h3>
                <h4 class="m-t-10 m-b-20 text-center">{email}</h4>

                <div class="form-group">
                <input type="text" class="form-control" name="inputUser" id="username" placeholder={data.enterNewUsername} parsley-trigger="change" data-parsley-id="6" required />
                </div>

                <div class="form-group">
                <input type="password" class="form-control" name="inputPassword" id="pass1" placeholder={data.enterNewPassword} data-parsley-id="8" required />
                </div>

                <div class="form-group">
                <input type="password" class="form-control" name="confirmPassword" id="confirmPassword" placeholder={data.ConfirmNewPassword} pattern=".{8,}" title={data.pwLessThan8}  required/>
                </div>

                <input type="hidden" name="token" id="token" value={token}/>
                <input type="hidden" name="uidb64" id="uidb64" value={uidb64}/>

                <div class="grey_btn m-b-20">
                <button type="submit" class="btn btn-block btn-default waves-effect waves-light btn-md p-t-5 p-b-5">{data.save}</button>
                </div>
                </form>

                <p class="text-right"><a href="/logout">{data.signOut}</a></p>

            </div>
          </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/setup.js